const types = [
  { key: 'refinance', label: 'Refinance', billable: true, chargeable: true },
  { key: 'purchase', label: 'Purchase', billable: true, chargeable: true },
  { key: 'renewal', label: 'Renewal', billable: false, chargeable: false },
  { key: 'b2b', label: 'B2B (Billable)', billable: true, chargeable: true },
  {
    key: 'b2b-no-fee',
    label: 'B2B ($0 Fee)',
    billable: false,
    chargeable: false
  }
];
export default types;
